import { FC } from "react";
import styled from "styled-components";

const Block = styled.div`
  margin-bottom: 5px;
  padding: 5px;
  border: 1px solid #ddd;
  width: 100%;
  max-height: 20vh;
  overflow-y: auto;

  div {
    padding: 5px;
    white-space: pre-wrap;    
  }

  .title {
    border-bottom: 1px solid #ddd;
  }
`;

interface IProps {
  title?: string;
  body?: string;
};

const TextViewer: FC<IProps> = ({
  title = '',
  body = '',
}) => {
  return (
    <Block>
      <div
        className="title"
        dangerouslySetInnerHTML={{ __html: title.replace(/\n/g, '<br />') }}
      />
      <div
        dangerouslySetInnerHTML={{ __html: body.replace(/\n/g, '<br />') }}
      />
    </Block>
  );
};

export default TextViewer;